import style from "../../../../assets/scss/sub/consultantHistory.module.scss";
import {ConsultationItem, ConsultationModalType} from "../../../../types/consultation";
import React from "react";
import {PageResponse} from "../../../../types/page";
import {useConsultationFunctions} from "./useConsultationFunctions";
import {useVoucherStore} from "../../../common/hooks/voucherStore";
import {useModal} from "../../../../hooks/hooks";
import {useConsultationPagination} from "./useConsultationPagination";
import {useConsultationModals} from "./ConsultationModalProvider";
import {useTranslation} from "react-i18next";
import {useMyPageFunctions} from "../../mypage/useMyPageFunctions";

interface Args {
    consultationHistory: PageResponse<ConsultationItem> | undefined;
    currentPage: number;
    handlePageChange: (_: number) => void
}

export function ConsultantHistoryColumns(
    {consultationHistory, currentPage, handlePageChange}: Args
) {
    const {t} = useTranslation("consultant");
    const {getStatusMessage, getButtonContent} = useConsultationFunctions();
    const {consultingVoucherCount} = useVoucherStore();
    const {openConfirmModal, openAlertModal} = useModal();
    const {modalActions} = useConsultationModals();
    const {endPage} = useConsultationPagination({
        totalElements: consultationHistory?.totalElements ?? 0
    });
    const {CommonPageField} = useMyPageFunctions();

    const onClickCounselingButton = (item: ConsultationItem) => {
        if (process.env.REACT_APP_MODE === "운영") {
            openAlertModal({
                title: t("modal.info.title"),
                desc: t("modal.info.desc")
            })
            return;
        }

        // 영어일때 로그인바가 없음
        if (item.status === null && consultingVoucherCount === 0) { // 상담신청 + 상담 이용권이 없는 경우
            openConfirmModal(
                {
                    title: t('modal.empty.title'),
                    desc: `${t('modal.empty.desc1')}\n${t('modal.empty.desc2')}`,
                },
                () => {
                    window.open(`/purchase-counselor`, "_blank", "noopener,noreferrer");
                }
            );
            return;
        }
        modalActions.toggleReserveModal(item)
    }

    return (
        <div>
            <div className={style.labelContainer}>
                <div className={style.firstLabel}>{t('detail.column.testType')}</div>
                <div className={style.secondLabel}>{t('detail.column.requestDate')}</div>
                <div className={style.thirdLabel}>{t('detail.column.detail')}</div>
                <div className={style.fourthLabel}>{t('detail.column.status')}</div>
            </div>
            {consultationHistory?.content && (
                <div className={style.resultInfoContainer}>
                    {consultationHistory.content.map((item: ConsultationItem) => (
                        <React.Fragment key={item.contentExecutedInfoIdx}>
                        <div className={style.resultInfoData}>
                            <div className={style.firstInfoData}>
                                {item.unitVoucherType === "KPASS" ? "K-PASS" : "D-CAS"}
                                <br/>
                                {`${item.testRound}${t('detail.row.testRound')}` || "-"}
                            </div>
                            <div className={style.secondInfoData}>
                                {item.desiredDate ? item.desiredDate : "-"}
                                {item.desiredTime ? (
                                    <>
                                        <br/>
                                        {item.desiredTime.slice(0, 5)}
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className={style.thirdInfoData}>
                                {getButtonContent(item, modalActions.toggleModal)}
                            </div>
                            <div
                                className={`${style.fourthInfoData} ${item.status ? style[item.status.toLowerCase()] : ""}`}>
                                {item?.status?.toLowerCase() === "allotted" ? (
                                    <>
                                            <span style={{cursor: "pointer"}}
                                                  onClick={() => modalActions.toggleModal({
                                                      consultation: item, modalType: ConsultationModalType.INFO
                                                  })}
                                                  className={`${style.allotted_consultant}`}>{item.consultantName}
                                            </span>
                                    </>
                                ) : null}
                                {!item.status ? (
                                    <button className={style.resultButton}
                                            onClick={() => {
                                                onClickCounselingButton(item)
                                            }}>
                                        {getStatusMessage(item.status ?? undefined)}</button>
                                ) : (
                                    <div style={{lineHeight: "140%"}}>{getStatusMessage(item.status)}</div>
                                )}
                            </div>
                        </div>
                        </React.Fragment>
                    ))}
                    {consultationHistory.content.length === 0 &&
                        <div className={style.noPaymentInfo}>{t('detail.row.emptyResult')}</div>}
                </div>
            )}

            <CommonPageField handlePageChange={handlePageChange} currentPage={currentPage} totalPages={endPage}/>
        </div>
    )
}